import { useCallback, useEffect, useState } from 'react';
import {
  EVENT_ANALYTICS_TYPE_SELECTED,
  trackUpdate,
} from '../../../../utils/matomoEvents';
import { PREPROCESSED_ANALYTICS } from '../../../../types/analytics';

const basicAnalytics = ['Time Series', 'Rose Plot', 'Scatter Plot'];
const firstPreviewAnalytics = ['Time Series'];

export const useAnalyticsNavigation = (
  analyticsDefinition: string,
  userGroupPermissions: any,
  user: any,
  isTnw: boolean,
  isAuthenticated: () => boolean,
  coordinates: number[],
  previewDatasetId: string,
  setShowLogin: (show: boolean) => void,
  isAnalytics: boolean,
  cancelAllOperation: () => void
) => {
  const [availableAnalytics, setAvailableAnalytics] = useState<any[]>([]);
  const [activePlotAnalytics, setActivePlotAnalytics] = useState<string[]>([]);
  const [isAdvanceAnalytics, setIsAdvanceAnalytics] = useState(false);

  useEffect(() => {
    if (!isAnalytics) return;
    if (activePlotAnalytics.length === 0) {
      setActivePlotAnalytics(firstPreviewAnalytics);
    }
  }, [isAnalytics]);

  useEffect(() => {
    if (!isAnalytics) return;
    if (analyticsDefinition) {
      const analytcsDefs = analyticsDefinition.split('|');

      const analytics = analytcsDefs
        .filter((a) => a !== Object.keys(PREPROCESSED_ANALYTICS)[0])
        .map((analyticDef: string) => {
          const isDisabled =
            basicAnalytics.includes(analyticDef) || isTnw
              ? false
              : userGroupPermissions?.analyticsList.toString().toLowerCase() ===
                'limited';

          return {
            id: analyticDef,
            name: analyticDef,
            basic: basicAnalytics.includes(analyticDef),
            disabled: isDisabled,
          };
        });

      const findActiveAnalytics = analytics.find(
        (item) => item.id === activePlotAnalytics[0]
      );
      if (!findActiveAnalytics) {
        setActivePlotAnalytics(firstPreviewAnalytics);
      }

      setAvailableAnalytics(analytics);
    }
  }, [analyticsDefinition, user, userGroupPermissions, isTnw, isAnalytics]);

  const handleAnalyticsTypeChanged = useCallback(
    (analytic: any) => {
      if (!isAuthenticated() && !basicAnalytics.includes(analytic.id)) {
        setShowLogin(true);
        return;
      }
      if (analytic.disabled === false) {
        cancelAllOperation();
        if (!basicAnalytics.includes(analytic.id)) {
          setIsAdvanceAnalytics(true);
        }
        setActivePlotAnalytics([analytic.id]);
        trackUpdate(
          EVENT_ANALYTICS_TYPE_SELECTED,
          coordinates,
          previewDatasetId,
          analytic.id.toLowerCase()
        );
      }
    },
    [coordinates, previewDatasetId, isAuthenticated, setShowLogin]
  );

  return {
    isAdvanceAnalytics,
    availableAnalytics,
    activePlotAnalytics,
    handleAnalyticsTypeChanged,
  };
};
